exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[data-v-5fd9b429] .current-filters {\n    padding-bottom: 0;\n}\n.table tr[data-v-5fd9b429],\n.table tr td[data-v-5fd9b429] {\n    vertical-align: middle;\n}\n.badge[data-v-5fd9b429] {\n    padding: 5px;\n    font-weight: 500;\n    font-size: 12px;\n}\n.coupon-text[data-v-5fd9b429] {\n    font-size: 15px;\n    margin-top: 10px;\n    display: inline-block;\n}\n", ""]);

// exports
